import {Vector3} from 'three'

import {CORNER_RADIUS} from '../../modules/cube/_config'
import type {LayoutConfig} from '../../modules/cube/_types'

const basePosition = new Vector3(0.0, -1, 0.0)

const calcPosition = (pos: Vector3) => {
  pos.add(basePosition)
  pos.x *= 1.0 + CORNER_RADIUS * 1.1
  pos.y *= 1.0 + CORNER_RADIUS * 1.1
  pos.z *= 1.0 + CORNER_RADIUS * 1.1

  return pos
}

const offsetStart = {
  position: new Vector3(0, -3, 0),
  rotation: new Vector3(0, 0, 0),
}

const leftOffsetX = 0.2
const tabletOffset = 0.6

const commonCubeConfig = {
  offsetStart,
  delay: 0.0,
  duration: 1,
  scale: 1,
}

const cubes = [
  {
    position: calcPosition(new Vector3(-4 + leftOffsetX, 0.0, 4 - leftOffsetX)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, -tabletOffset),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-4 + leftOffsetX, 0.0, 3 - leftOffsetX)),
    rotation: new Vector3(Math.PI * 0.5, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, -tabletOffset),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-3 + leftOffsetX, 0.0, 3 - leftOffsetX)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'mosaic',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, -tabletOffset),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-2 + leftOffsetX, 0.0, 2 - leftOffsetX)),
    rotation: new Vector3(Math.PI * 0.5, 0, 0),
    cubeType: 'normal2',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(tabletOffset, 0, -tabletOffset),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  // center
  {
    position: calcPosition(new Vector3(0, 0.0, 0)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(0, 0.0, -1)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'rainbow',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(1, 0.0, -1)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'glass',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(1, 0.0, -2)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'normal',
    isGlassRender: true,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(2, 0.0, -2)),
    rotation: new Vector3(0, 0, 0),
    cubeType: 'glass',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },

  // right
  {
    position: calcPosition(new Vector3(3, 0.0, -3)),
    rotation: new Vector3(0.0, Math.PI * 0.5, Math.PI * 0.5),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(3, 0.0, -4)),
    rotation: new Vector3(Math.PI * 0.5, 0, 0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(4, 0.0, -4)),
    rotation: new Vector3(0, -Math.PI * 0.5, Math.PI * 0.5),
    cubeType: 'normal2',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
]

const parabola = (x: number) => {
  return Math.pow(2 * x - 1, 2)
}

const valley = (x: number) => {
  return Math.abs(2 * x - 1)
}

// cubes.forEach((cube, index) => {
//   cube.delay = index * 0.1;
//   cube.duration = 1.0;
// })

cubes.forEach((cube, index) => {
  const p = index / (cubes.length - 1)
  cube.delay = valley(p)
  cube.duration = 1.0
})

export default {
  rotation: new Vector3(Math.PI * 0.2, -Math.PI * 0.25, 0),
  rotationOrder: 'XYZ',
  groupAnim: {
    start: new Vector3(0, -1, 0),
    end: new Vector3(0, 0, 0),
    duration: 4.0,
    ease: 'expo.out',
  },
  cubes,
} as LayoutConfig
